export const ThemeConstants = {
    DARK: 'dark',
    LIGHT: 'light',
};
